import { render, staticRenderFns } from "./ButtonScroll.vue?vue&type=template&id=3d90ecdd"
import script from "./ButtonScroll.vue?vue&type=script&lang=js"
export * from "./ButtonScroll.vue?vue&type=script&lang=js"
import style0 from "./ButtonScroll.vue?vue&type=style&index=0&id=3d90ecdd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports